import React, { useEffect } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { Form } from '@fiverr-private/forms';
import { PasswordHints, ForgetPasswordLink } from '@fiverr-private/identification_core';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../../events';
import { translate } from '../../../utils/translate';
import { useStepsContext } from '../../StepsContext';
import { FormSubmitButton } from '../common/FormSubmitButton';
import { useEmailIdentificationForm } from './hooks/useEmailIdentificationForm';
import { PASSWORD_SERVER_ERROR, useSubmitHandler } from './hooks/useSubmitHandler';
import { UsernameOrEmailField } from './UsernameOrEmailField';
import { PasswordField } from './PasswordField';

export const EmailIdentificationStep = () => {
    const { goToStep } = useStepsContext();

    const {
        loading,
        setLoading,
        isSignUp,
        methods,
        password,
        usernameOrEmail,
        passwordError,
        onUsernameOrEmailChange,
    } = useEmailIdentificationForm();

    const { onSubmit } = useSubmitHandler({ isSignUp, setError: methods.setError, setLoading });

    useEffect(() => {
        globalGrafanaReporter.count('identification.%{platform}.email_identification.show');
        globalBigQueryReporter.send('identification.email_identification.show');
    }, []);

    return (
        <Container display="flex" direction="column" flexGrow="1" gap="10">
            <Heading size={{ default: 'h_lg' }} fontWeight="bold">
                {translate('steps.email_identification.title')}
            </Heading>

            <Form flexGrow="1" methods={methods} onSubmit={onSubmit}>
                <Container display="flex" direction="column" flexGrow="1" gap="4">
                    <UsernameOrEmailField loading={loading} onChange={onUsernameOrEmailChange} />
                    <Container>
                        <PasswordField
                            isSignUpMode={isSignUp}
                            passwordServerError={passwordError?.type === PASSWORD_SERVER_ERROR}
                        />
                        {isSignUp ? (
                            <Container marginTop="3">
                                <PasswordHints password={password} />
                            </Container>
                        ) : (
                            <ForgetPasswordLink
                                usernameOrEmail={usernameOrEmail}
                                onResetPassword={() => goToStep('reset_password')}
                            />
                        )}
                    </Container>

                    <Container marginTop="auto">
                        <FormSubmitButton
                            loading={loading}
                            label={translate(
                                isSignUp ? 'steps.email_identification.continue' : 'steps.email_identification.sign_in'
                            )}
                        />
                    </Container>
                </Container>
            </Form>
        </Container>
    );
};
